/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_TitleInputs */

const en_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder Permissions`)
};

const fr_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations du dossier`)
};

const de_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordnerberechtigungen`)
};

const it_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizzazioni cartella`)
};

const ru_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Права доступа к папкам`)
};

const es_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos de carpeta`)
};

const zh_cn2_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹权限`)
};

const ja_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ権限`)
};

const hi_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर अनुमतियाँ`)
};

const pt_pt2_explorer_info_permissions_title = /** @type {(inputs: Explorer_Info_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões de pasta`)
};

/**
* | output |
* | --- |
* | "Folder Permissions" |
*
* @param {Explorer_Info_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_title = /** @type {((inputs?: Explorer_Info_Permissions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_permissions_title(inputs)
	if (locale === "de") return de_explorer_info_permissions_title(inputs)
	if (locale === "it") return it_explorer_info_permissions_title(inputs)
	if (locale === "ru") return ru_explorer_info_permissions_title(inputs)
	if (locale === "es") return es_explorer_info_permissions_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_permissions_title(inputs)
	if (locale === "ja") return ja_explorer_info_permissions_title(inputs)
	if (locale === "hi") return hi_explorer_info_permissions_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_permissions_title(inputs)
	return en_explorer_info_permissions_title(inputs)
});